import Spinner from 'olive-react-myoneui/lib/Spinner';
import Skeleton from "react-loading-skeleton";

export function Loader() {
  return (
    <div className="vh-100 w-100 bg-white d-flex align-items-center justify-content-center">
      <div className="d-flex align-items-center justify-content-center flex-column gap-2">
        <Spinner animation="border" variant="secondary" />
        <span>Please, wait. Loading...</span>
      </div>
    </div>
  );
  // return null;
}

export function UploadLoader() {
  return (
    <div className="vh-100 w-100 d-flex align-items-center justify-content-center myk__upload-loader">
      <div className="d-flex align-items-center justify-content-center flex-column gap-2">
        <Spinner animation="border" variant="secondary" />
        <span>Please, wait. </span>
      </div>
    </div>
  );
  // return null;
}

export function CourseItemLoader({type, items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className={'myk__course-wrapper ' + (type !== 'course' || type !== 'bundle' ? 'no-course' : '')}>
        <div key={i} className={'myk__course-block'}>
          <div className="myk__course-img">
            <Skeleton borderRadius={'0.24rem'} height={'415px'} />
          </div>
          <div className="myk__course-desc">
            <h1><Skeleton width={'110px'} height={'20px'} /></h1>
            <div className="myk__course-meta-data mt-1 mb-3">
              <span><Skeleton width={'24px'} height={'14px'} /></span>
              <span><Skeleton width={'24px'} height={'14px'} /></span>
              <span><Skeleton width={'24px'} height={'14px'} /></span>
            </div>
            <Skeleton borderRadius={'10rem'} width={'100%'} height={'26px'} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {type === 'course' || type === 'bundle' ? (
      <div className= 'myk__stu-courses-list no-courses-list'>
        {viewRender}
      </div>
      ) : (
        viewRender
      )}
    </>
  );
}

export function EventItemLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className={'myk__course-wrapper '}>
        <div key={i} className={'myk__course-block'}>
          <div className="myk__course-img">
            <Skeleton borderRadius={'0.24rem'} height={'415px'} />
          </div>
          <div className="myk__course-desc">
            <div className="myk__event-metadata">
              <span><Skeleton width={'130px'} height={'14px'} /></span>
            </div>
            <h1><Skeleton width={'175px'} height={'20px'} /></h1>
            <div className="myk__event-metadata">
              <Skeleton borderRadius={'10rem'} width={'50%'} height={'26px'} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className= 'myk__stu-events-list no-event-list'>
        {viewRender}
      </div>
    </>
  );
}

export function EnrollmentProgressLoader() { 
  return (
    <div className="no-learning-progress-content">
      <Skeleton height={'200px'}/>
    </div>
  )
}

export function IntroCardLoader() {
  return (
    <div className="empty-intro-card-wrapper">
      <h2><Skeleton width={"33%"} height={"26px"}/></h2>
      <div className="intro-card-holder">
        <div className="empty-intro-card">
          <Skeleton borderRadius={"1.25rem"} width={"272.655px"} height={"193.086px"}/>
        </div>
        <div className="intro-card-info">
          <Skeleton width={"48%"} height={"13px"} />
          <Skeleton width={"48%"} height={"20px"} />
          <br/>
          <h4><Skeleton height={"8px"}/></h4>
        </div>
      </div>
    </div>
  )
}

export function UpcomingEventLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div key={i} className="myk__stu-event-activity p-0 mb-3">
        <div className="desc-carousel desc-event">
          <div className="event-date">
          </div>
          <div className="event-desc">
            <div className="event-heading d-flex align-items-center justify-content-between gap-2">
              <Skeleton width={'200px'} height={'22px'} />
            </div>
            <div className="icon-teacher-expiry d-flex align-items-center gap-1 mb-2">
              <Skeleton width={'370px'} height={'18px'} />
            </div>
            <div className="icon-teacher-expiry d-flex align-items-center gap-1 mb-2">
              <Skeleton width={'220px'} height={'16px'} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>{viewRender}</>  
  )
}

export function CourseContentLoader() {
  return (
    <div className="myk__stu-course-tabs_wrapper">
      <div className="row">
        <div className="col-sm-12">
          <NavTabLoader />
          <div className="myk__stu-details-overview no-left-padding">
            <div className="row">
              <div className="col-xl-8">
                <div className="myk__stu-course-overview pe-lg-5 pl-0">
                  <div className="myk__stu-course-about">
                    <h2><Skeleton width={'30%'} height={'24px'} /></h2>
                  </div>
                  <ContentLoader items={2} />
                </div>
              </div>
              <div className="col-sm-4">
                <div className="myk__stu-instructor-wrapper px-0 px-xxl-4">
                  <h2><Skeleton width={'30%'} height={'24px'} /></h2>
                  <TutorLoader items={2} />
                  <InfoBlockLoader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function NavTabLoader() {
  return (
    <div className="row">
      <div className="col-sm-2">
        <Skeleton width={'100%'} height={'20px'} />
      </div>
      <div className="col-sm-1">
        <Skeleton width={'100%'} height={'20px'} />
      </div>
      <div className="col-sm-1">
        <Skeleton width={'100%'} height={'20px'} />
      </div>
      <div className="col-sm-1">
        <Skeleton width={'100%'} height={'20px'} />
      </div>
      <div className="col-sm-2">
        <Skeleton width={'80%'} height={'20px'} />
      </div>
    </div>
  );
}

export function ContentLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div>
        <p><Skeleton width={'100%'} height={'16px'} /></p>
        <p><Skeleton width={'80%'}  height={'16px'} /></p>
        <p><Skeleton width={'60%'}  height={'16px'} /></p>
        <p><Skeleton width={'40%'}  height={'16px'} /></p>
        <p><Skeleton width={'20%'}  height={'16px'} /></p>
        <br />
      </div>
    );
  }
  return (
    <>{viewRender}</>
  )
}

export function TutorLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className="information-block bg-information-white p-0 mb-5">
        <div className="information-wrap">
          <div className="information-holder align-items-center gap-2 myk__stu-profile-wrapper">
            <Skeleton circle={true} width={'60px'} height={'60px'} />
            <div className="information-detail">
              <h3><Skeleton width={'90px'} height={'20px'} /></h3>
              <p><Skeleton width={'150px'} height={'10px'} /></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>{viewRender}</>
  )
}

export function InfoBlockLoader() {
  return (
    <div className="myk__stu-course-info">
      <h2><Skeleton width={'30%'} height={'24px'} /></h2>
      <ul>
        <li>
          <Skeleton width={'15px'} height={'15px'} />
          <Skeleton width={'90px'} height={'15px'} />
        </li>
        <li>
          <Skeleton width={'15px'} height={'15px'} />
          <Skeleton width={'90px'} height={'15px'} />
        </li>
        <li>
          <Skeleton width={'15px'} height={'15px'} />
          <Skeleton width={'90px'} height={'15px'} />
        </li>
        <li>
          <Skeleton width={'15px'} height={'15px'} />
          <Skeleton width={'90px'} height={'15px'} />
        </li>
      </ul>
    </div>
  )
}

export function CourseCurriculumLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className="course-progress myk__stu-courses-progress-wrapper mb-1">
        <div className="accordion">
          <div className="accordion-item">
            <div className="flex-wrap accordion-header empty-accordion">
              <h3><Skeleton width={'100%'} height={'22px'} /></h3>
            </div>
            <div className="accordion-collapse collapse show">
              <div className="pt-1 accordion-body">
                <div className="myk__stu-lecture-subtopics accordion">
                  <div class="accordion-item">
                    <Skeleton width={'100%'} height={'20px'} />
                    <br/>
                    <Skeleton width={'100%'} height={'20px'} />
                    <br/>
                    <Skeleton width={'100%'} height={'20px'} />
                    <br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>{viewRender}</>
  )
}

export function EventThumbnailLoader() {
  return (
    <div className="mb-5">
      <Skeleton borderRadius={'1.5rem'} width={'100%'} height={'200px'} />
    </div>
  );
}

export function EventSessionLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className="myk__stu-event_schedule-wrapper mb-4">
        <div className="event-schedule-content">
          <div className="event-title">
            <div className="event-img-wrapper">
              <Skeleton borderRadius={'0.625rem'} width={'60px'} height={'60px'} />
            </div>
            <div class="pe-2"><h1><Skeleton width={'140px'} height={'15px'} /></h1></div>
            <div class="event-venue-date"><h1><Skeleton width={'140px'} height={'15px'} /></h1></div>
            <div className="lecture-count myk__stu-event_session-action flex-none">
              <Skeleton borderRadius={'5rem'} width={'54px'} height={'15px'} />
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <>{viewRender}</>
  )
}

export function EventContentLoader() {
  return (
    <div className="myk__stu-course-tabs_wrapper">
      <div className="row">
        <div className="col-sm-12">
          <div className="myk__stu-details-overview no-left-padding">
            <div className="row">
              <div className="col-xl-8">
                <div className="myk__stu-course-overview pe-lg-5 pl-0">
                  <div className="myk__stu-course-about">
                    <h2><Skeleton width={'30%'} height={'24px'} /></h2>
                  </div>
                  <ContentLoader items={1} />
                  <div class="mt-4">
                    <h4><Skeleton width={'30%'} height={'24px'} /></h4>
                    <h5><strong><Skeleton width={'24%'} height={'18px'} /></strong></h5>
                    <EventSessionLoader items={2} />
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="myk__stu-instructor-wrapper px-0 px-xxl-4">
                  <h2><Skeleton width={'30%'} height={'24px'} /></h2>
                  <TutorLoader items={2} />
                  <InfoBlockLoader />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function NewsfeedBlockLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
    <div className="information-block bg-information-white myk__stu-info-block mb-3">
      <div className="information-wrap mb-0">
        <div className="information-holder gap-2 align-items-start">
          <Skeleton borderRadius={"1.25rem"} width={"40px"} height={"40px"}/>
          <div className="information-detail mt-1">
            <p>
              <Skeleton count={1} height={"18px"} />
              <Skeleton count={1} height={"10px"} />
            </p>
          </div>
        </div>
      </div>
      <p style={{marginBottom: "10px"}}><Skeleton count={4}/></p>
      <Skeleton height={"150px"} style={{marginBottom: "10px"}}/>
      <div className="myk__stu-comm-doc-item mt-2 gap-3">
        <p style={{marginBottom: "10px", width:"100%"}}><Skeleton count={4} style={{marginBottom: "5px"}} /></p>
        <p style={{marginBottom: "10px", width:"100%"}}><Skeleton count={4} style={{marginBottom: "5px"}} /></p>
      </div>
      <div className="d-flex align-items-center justify-content-between gap-4 w-100">
        <div className="flex-none w-25">
          <Skeleton count={1} height={"20px"} width={"100%"} />
        </div>
        <div className="flex-none w-25">
          <Skeleton count={1} height={"20px"} width={"100%"} />
        </div>
      </div>
    </div>
    )
  }
  return (
    <>
      <div className='no-newsfeeds-list'>
        {viewRender}
      </div>
    </>
  )
}

export function DocDetailsLoader({ items }) {
  let viewRender = [];

  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <li key={i}>
        <Skeleton width={"25%"} height={"8px"} style={{ marginBottom: "0" }} />
        <h5>
          <Skeleton
            count={1}
            width={"70%"}
            height={"10px"}
            style={{ marginBottom: "0", marginTop: "-9px" }}
          />
        </h5>
      </li>
    );
  }

  return (
    <div className="myk__stu-doc-file_details">
      <div className="mk__stu-skeleton-header">
        <h4>
          <Skeleton count={1} width={"100%"} height={"18px"} />
        </h4>
        <div>
          <Skeleton count={1} width={"100%"} height={"18px"} />
        </div>
      </div>
      <div className="myk__stu-doc_file-details">
        <ul>{viewRender}</ul>
      </div>
    </div>
  );
}

export function DocActivityLoader({ items }) {
  let viewRender = [];

  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
    <div className="information-wrap mb-3">
      <div key={i} className="information-holder gap-2 align-items-start">
        <Skeleton borderRadius={"1.25rem"} width={"32px"} height={"32px"}/>
        <div className="information-detail mt-1">
          <p>
            <Skeleton count={1} height={"15px"} />
            <Skeleton count={1} height={"8px"} />
          </p>
        </div>
      </div>
    </div>
    );
  }

  return (
    <div className="myk__stu-doc-activity-logs">
        {viewRender}
    </div>
  );
}

export function DocVersionHistoryLoader({ items }) {
  let viewRender = [];

  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className="myk__stu-doc_version-item d-block mb-3">
        <div className="information-wrap mb-0">
          <div className="information-holder gap-2 align-items-start">
            <Skeleton borderRadius={"1.25rem"} width={"32px"} height={"32px"}/>
            <div className="information-detail mt-1">
              <p>
                <Skeleton count={1} height={"15px"} />
                <Skeleton count={1} height={"8px"} />
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="myk__stu-doc-versions-logs">
        {viewRender}
    </div>
  );
}

export function DocFileFolderBlockLoader({ items }) {
  let viewRender = [];

  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className="myk__stu-dms-folder card border-0">
        <div className="myk__stu-dms_folder-inner card-body d-block pb-1">
          <div className="information-wrap mb-0">
              <div className="information-holder gap-4 align-items-start">
                <Skeleton borderRadius={".35rem"} width={"32px"} height={"32px"}/>
                <div className="information-detail mt-1">
                  <p>
                    <Skeleton count={1} height={"15px"} />
                    <Skeleton count={1} height={"8px"} />
                  </p>
                </div>
              </div>
            </div>
        </div>
      </div>
    )
  }
  return(
    <>
    {viewRender}
    </>
  );
}

export function TransferEventLoader() {

  return(
    <>
      <div class="myk__stu-transfer-orders border-0 card">
        <div class="card-header">
          <div class="myk_stu-page-header mb-0">
            <h2><Skeleton width={'140px'} height={'30px'} /></h2>
          </div>
        </div>
        <div class="card-body">
          <div class="myk__stu-order-item">
            <div class="align-items-start row">
              <div class="mb-3 mb-xl-0 col-xl-3 col-lg-5 col-sm-5">
                <Skeleton borderRadius={'0.58rem'} width={'158px'} height={'108px'} />
              </div>
              <div class="card-info col-xl-9 col-lg-7 col-sm-7">
                <h3><Skeleton width={'60px'} height={'24px'} /></h3>
                <p>
                  <Skeleton width={'15px'} />
                  <span><Skeleton width={'218px'} /></span>
                </p>
                <p>
                  <Skeleton width={'15px'} />
                  <span><Skeleton width={'218px'} /></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <span class="card-divider my-1 mx-3"></span>
        <div class="d-block w-100 card-footer">
          <div class="myk_stu-page-header mb-2">
            <h2><Skeleton width={'105px'} /></h2>
          </div>
          <div class="myk__stu-transferable_events">
            <div class="myk__stu-transferable_event-item_wrapper ">
              <div class="form-check">
                <label for="myk__stu-event-radio-965" class="form-check-label">
                  <div class="myk__stu-transferable_event-item">
                    <div class="myk__stu-event-dates">
                      <h4><Skeleton width={'138px'} height={'16px'} /></h4>
                      <h6>
                        <Skeleton width={'188px'} />
                      </h6>
                      <h6>
                        <Skeleton width={'188px'} />
                      </h6>
                    </div>
                    <div>
                      <Skeleton borderRadius={'0.25rem'} width={'90px'} height={'25px'} />
                    </div>
                    <div class="myk__stu-event-price-type">
                      <Skeleton borderRadius={'0.25rem'} width={'90px'} height={'25px'} />
                    </div>
                  </div>
                </label>
              </div>
            </div>
          </div>
          <div class="mt-4 row">
            <div class="myk__stu-event-tnc col-xl-9 col-lg-7 col-sm-8">
              <div class="form-check">
                <Skeleton width={'436px'} />
              </div>
            </div>
            <div class="myk__stu-event-tnc text-end mt-3 mt-xl-0 col-xl-3 col-lg-5 col-sm-4">
              <Skeleton borderRadius={'0.65rem'} width={'150px'} height={'42px'} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export function SelfCancellationEvent() {
  return(
    <>
    <div class="myk__stu-transfer-orders border-0 card">
        <div class="card-header">
          <div class="myk_stu-page-header mb-0">
            <h2><Skeleton width={'140px'} height={'30px'} /></h2>
          </div>
        </div>

        <div class="card-body">
          <div>
            <div className="myk__order-group">
              <div className="myk__stu-order-info">
                <div class="align-items-start row">
                  <div class="myk__stu-order-details col-xl-8 col-lg-8 col-sm-12">
                    <h3><Skeleton width={'150px'} height={'30px'} /></h3>
                    <p><Skeleton width={'120px'} height={'18px'} /></p>
                    <p><Skeleton width={'95px'} height={'18px'} /></p>
                  </div>
                  <div className="myk__stu-order-download text-lg-end mb-3 mb-lg-0 col-xl-4 col-lg-4 col-sm-12">
                    <Skeleton borderRadius={'0.52rem'} width={'173px'} height={'43px'} />
                  </div>
                </div>
              </div>

              <div className="myk__stu-order-item">
                <div className="align-items-start row">
                  <div class="mb-3 mb-xl-0 col-xl-3 col-lg-5 col-sm-5">
                    <Skeleton borderRadius={'0.56rem'} width={'155px'} height={'115px'} />
                  </div>
                  <div class="card-info col-xl-9 col-lg-7 col-sm-7">
                    <h3>
                      <span class="myk__stu-order-title"><Skeleton width={'200px'} height={'28px'} /></span>
                      <span class="myk__stu-order-price"><Skeleton width={'40px'} height={'28px'} /></span>
                    </h3>
                    <p><Skeleton width={'15px'} /><span><Skeleton width={'90px'} /></span></p>
                    <Skeleton borderRadius={'0.56rem'} width={'176px'} height={'43px'} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="d-block w-100 card-footer">
          <div class="mt-1 row">
            <div class="myk__stu-event-tnc text-end mt-3 mt-xl-0 col-xl-3 col-lg-5 col-sm-4">
              <Skeleton borderRadius={'0.56rem'} width={'191px'} height={'43px'} />
            </div>
          </div>
        </div>
    </div>
    </>
  );
}

export function FormLoader({ items }) {
  let viewRender = [];

  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div class="col-xl-6 mb-4">
        <span><Skeleton width={'130px'} height={'16px'}  /></span>
        <span><Skeleton width={'100%'} height={'32px'} /></span>
      </div>
    )
  }
  return (
    <div class="border-0 card p-0">
        <div class="row">
        {viewRender}
        </div>
        <div class="action-btns text-end d-flex align-items-center gap-2 justify-content-end">
          <Skeleton width={'60px'} height={'16px'} />
          <Skeleton width={'100px'} height={'32px'} />
        </div>
    </div>
  );
}


export function CertificateItemLoader({items}) {
  let viewRender = [];
  for (let i = 1; i <= parseInt(items); i++) {
    viewRender.push(
      <div className={'myk__course-wrapper'}>
        <div key={i} className={'myk__course-block'}>
          <div className="myk__course-img">
            <Skeleton borderRadius={'0.24rem'} height={'205px'} />
          </div>
          <div className="myk__course-desc">
            <Skeleton borderRadius={'10rem'} width={'100%'} height={'26px'} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='no-courses-list certificate-loading-list d-flex gap-3 overflow-hidden'>
        {viewRender}
      </div>
    </>
  );
}

export default { 
  Loader, 
  UploadLoader,
  CourseItemLoader, 
  EventItemLoader, 
  EnrollmentProgressLoader, 
  IntroCardLoader, 
  UpcomingEventLoader, 
  CourseContentLoader, 
  CourseCurriculumLoader, 
  EventThumbnailLoader, 
  EventContentLoader, 
  NewsfeedBlockLoader, 
  DocDetailsLoader, 
  DocActivityLoader, 
  DocVersionHistoryLoader,
  DocFileFolderBlockLoader,
  TransferEventLoader,
  SelfCancellationEvent
}
